import { ArrowRight } from 'lucide-react';
import React from 'react';

import { cn } from '@/lib/utils';

import { ActivityBadge } from './ActivityBadge';

export interface ActivityStatusTransitionProps {
  from: string;
  to: string;
  className?: string;
}

export const ActivityStatusTransition: React.FC<
  ActivityStatusTransitionProps
> = ({ from, to, className }) => {
  return (
    <div
      className={cn('flex items-center gap-2 text-sm text-gray-600', className)}
    >
      <ActivityBadge variant="default">{from}</ActivityBadge>
      <ArrowRight className="h-4 w-4" />
      <ActivityBadge variant="default">{to}</ActivityBadge>
    </div>
  );
};
